import type { PropsWithChildren } from 'react';

import { UploadContainerStyled } from './styles/UploadContainerStyled'
import { type UploadCommonProps } from '../../Upload'

export interface IUploadContainerProps<UploadExtraProps = {}> {
  commonProps: UploadCommonProps<UploadExtraProps>
}

export const UploadContainer = (
  props: PropsWithChildren<IUploadContainerProps>
) => {
  const {
    commonProps: { isReadonly },
  } = props

  return !isReadonly ? <UploadContainerStyled {...props} /> : null
}
